import { api } from './client';

export interface QuoteApprovalRow {
  rfqId: number;
  rfqNo: string;
  rfqStatus: string;
  rfqItemId: number;
  itemName: string;
  qty: string;
  unit: string;
  targetPrice: string | null;
  decision: 'Pending' | 'Approved' | 'Override' | 'Rejected';
  decidedAt: string | null;
  selectedQuoteItemId: number | null;
  selectedVendor: string | null;
  selectedUnitPrice: number | null;
  overrideReason: string | null;
  recommendedQuoteItemId: number | null;
  savingsVsHighest: number;
  quotes: Array<{
    quoteItemId: number;
    vendorId: number;
    vendor: string;
    unitPrice: number;
    deliveryDays: number | null;
    aiScore: number | null;
    isBest: boolean;
    total: number;
  }>;
}

export async function listQuoteApprovals(rfqId?: number, showAll?: boolean): Promise<QuoteApprovalRow[]> {
  const r = await api.get<QuoteApprovalRow[]>('/quote-approval', {
    params: { ...(rfqId ? { rfqId } : {}), ...(showAll ? { showAll: true } : {}) },
  });
  return r.data;
}

export async function approveQuote(rfqItemId: number, selectedQuoteItemId: number) {
  const r = await api.post(`/quote-approval/${rfqItemId}/approve`, { selectedQuoteItemId });
  return r.data;
}

export async function overrideQuote(rfqItemId: number, selectedQuoteItemId: number, reason: string) {
  const r = await api.post(`/quote-approval/${rfqItemId}/override`, {
    selectedQuoteItemId,
    reason,
  });
  return r.data;
}

export async function rejectQuote(rfqItemId: number) {
  const r = await api.post(`/quote-approval/${rfqItemId}/reject`);
  return r.data;
}

export async function generatePos(rfqId: number) {
  const r = await api.post<{ created: { id: number; poNo: string; vendorId: number; grandTotal: number }[] }>(
    '/quote-approval/generate-pos',
    { rfqId },
  );
  return r.data;
}
